import { Button, Stack, Typography } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import _ from "lodash";
import { useNavigate } from "../../../../../utils/hooks";
import Content from "../../../../../utils/medicalDocuments/Content";
import Type from "../../../../../utils/medicalDocuments/Type";

const Diagnosis = ({ medicalDocument }) => {
  const { diagnosis } = medicalDocument;
  return (
    <Typography
      sx={{
        color: "grey.main",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {diagnosis}
    </Typography>
  );
}

const DetailButton = ({ medicalDocument }) => {
  const navigate = useNavigate();
  const { id, type, patient: { id: patientId } } = medicalDocument;

  return (
    <Button variant="contained" sx={{ width: "fit-content" }} onClick={() => navigate(`/details-document/${id}`, { state: { backPath: `/patients/${patientId}` } })}>
      <Stack spacing={1} direction="row" alignItems="center">
        <Typography color="white">Ver {type == 'order' ? 'orden' : 'receta'}</Typography>
        <ArrowForwardIcon fontSize="2rem" />
      </Stack>
    </Button>
  );
};

const MedicalDocumentBrief = ({ medicalDocument }) => {
  const { type } = medicalDocument;

  return (
    <Stack spacing={2} p={1}>
      <Stack spacing={2} direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "start", sm: "center" }}>
        <Type title={type} />
        <Content medicalDocument={medicalDocument} />
      </Stack>
      <Diagnosis medicalDocument={medicalDocument} />
      <DetailButton medicalDocument={medicalDocument} />
    </Stack>
  );
};

export default MedicalDocumentBrief;